export const Code = () => {
  const { search } = window.location;
  const code = search.split("code=")[1]?.split("&")?.[0];
  const organizationName = search
    .split("organizationName=")[1]
    ?.split("&")?.[0];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: 390,
        margin: "0 auto",
        alignItems: "center",
      }}
    >
      <img
        src="/images/logo.png"
        style={{ width: 160, height: 31, marginTop: 40, objectFit: "contain" }}
        alt="orzo class logo"
      />
      <span style={{ fontWeight: 700, fontSize: 20, marginTop: 32 }}>
        {organizationName
          ? `${decodeURIComponent(organizationName)}의 초대장`
          : "잘못된 초대장입니다"}
      </span>
      <span style={{ fontWeight: 700, fontSize: 24, marginTop: 12 }}>
        {code ? `초대코드: ${code}` : ""}
      </span>
      <span
        style={{
          fontWeight: 400,
          fontSize: 20,
          marginTop: 32,
          color: "#777",
          textAlign: "center",
        }}
      >
        태블릿에서 오르조 앱을 다운로드 받아
        <br />
        마이페이지에서 입력하세요
      </span>
      <img
        src="/images/code_example.png"
        style={{
          width: "100%",
          maxWidth: 358,
          height: 480,
          objectFit: "contain",
          marginTop: 40,
          marginBottom: 60,
        }}
        alt="code_example"
      />
    </div>
  );
};
